<section class="product-details  section-main-padding">
    <h1 class="page-title">Product Detail</h1>
    <div class="auto-container">
        <div class="product-details-content">
            <div class="row clearfix">
                <div class="col-lg-4 col-md-12  image-column">
                    <div class="slider-inner">
                        <div class="bx-wrapper">
                            <div class="bx-viewport">
                                <div class="bxslider">
                                    <div class="slider-content" #content>
                                        <div class="slider-contentSub">
                                            <div class="slider-pager">
                                                <ul class="thumb-box p-0">
                                                    <li *ngFor="
                                let imageList of productDetails?.imagesArray;
                                let i = index
                              " (click)="getImageActive(i, imageList.imageName)">

                                                        <a aria-label="image" data-slide-index="i">
                                                            <figure class="m-0">

                                                                <img *ngIf="imageList.isVideo==null" alt="altImg"
                                                                    src="{{ imageUrl }}/images/{{imageList.imageName}}"
                                                                    [ngClass]="activeImageIndex === i ? 'active' : '' " />

                                                                <img *ngIf="imageList.isVideo!=null" alt="thumnailImg"
                                                                    src="{{imageUrl}}{{imageList.thumnailName}}"
                                                                    [ngClass]="activeImageIndex === i ? 'active' : ''" />

                                                                <div *ngIf="imageList.isVideo!=null"
                                                                    style="position: absolute; top: 35%; left: 33%;">
                                                                    <i class="fa-regular fa-circle-play  fa-3x"
                                                                        style="color: #DA292A;"></i>
                                                                </div>
                                                            </figure>
                                                        </a>
                                                    </li>
                                                </ul>
                                            </div>
                                            <div class="product-image">
                                                <ng-container *ngFor="let imageList of productDetails?.imagesArray;">
                                                    <figure class="image"
                                                        [ngStyle]="{'display': currentImage == imageList.imageName ? '' : 'none'}">

                                                        <a href="{{ imageList.isVideo!=null?imageUrl:(imageUrl+'/images/') }}{{imageList.imageName}}"
                                                            style="position: relative; display: inline-block;"
                                                            class="lightbox-image" data-fancybox="gallery">

                                                            <img *ngIf="imageList.isVideo==null"
                                                                [alt]="productDetails.pageTitle"
                                                                src="{{ imageUrl }}/images/{{imageList.imageName}}" />

                                                            <img *ngIf="imageList.isVideo!=null"
                                                                [alt]="productDetails.pageTitle"
                                                                src="{{ imageUrl }}{{imageList.thumnailName}}" />

                                                            <div style="position: absolute; top: 45%; left: 45%;">
                                                                <i *ngIf="imageList.isVideo!=null"
                                                                    class="fa-regular fa-circle-play  fa-4x"
                                                                    style="color: #DA292A;"></i>
                                                            </div>

                                                        </a>
                                                    </figure>
                                                </ng-container>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="bx-controls"></div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-8 col-md-12  content-column">
                    <div class="product-details">
                        <h2>{{ productDetails.pname }}</h2>
                        <div class="item-price">
                            <h3>
                                <span>₹{{ productDetails.mrp }}</span> ₹{{
                                productDetails.discountPrice
                                }}
                            </h3>
                        </div>
                        <div class="text">
                            <p>
                                {{ productDetails.shortDescription }}
                            </p>
                        </div>
                        <div class="other-links">
                            <ul class="category list clearfix p-0">
                                <li class="mx-1">Type:</li>
                                <li>
                                    <a aria-label="product type">{{ productDetails.type }}</a>
                                </li><br>
                                <li class="mx-1">Quantity:</li>
                                <li>
                                    <a aria-label="quantity">{{productDetails.netWeight}}
                                        {{productDetails.unitName}}</a>
                                </li>
                            </ul>
                        </div>
                        <div class="othre-options">
                            <div class="item-quantity" *ngIf="productDetails.isStockPresent">
                                <button class=" decr" aria-label="quantity"
                                    (click)="changeQuantity(productDetails, true)" type="button">
                                    <i class="fa fa-minus"></i></button>
                                <input class="" type="number" name="quantity" min="1"
                                    [(ngModel)]="productDetails.quantity"
                                    (keyup)="quantityChange($event, productDetails)" disabled />
                                <button class=" incr" aria-label="quantity"
                                    (click)="changeQuantity(productDetails, false)" type="button">
                                    <i class="fa fa-plus"></i>
                                </button>
                            </div>
                            <div class="btn-box">
                                <button type="button" class="theme-btn" [disabled]="!productDetails.isStockPresent"
                                    aria-label="add to cart" (click)="addToCart(1)"> {{ productDetails.isStockPresent ?
                                    'Add To Cart' : 'Out of stock' }}</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="product-discription">
            <div class="tabs-box">
                <div class="tab-btn-box">
                    <h2 class="descTit" data-tab="#tab-1">Description</h2>
                </div>
                <div class="tabs-content">
                    <div class="tab active-tab" id="tab-1">
                        <div class="text">
                            <h3>{{ productDetails.productDescTitle }}</h3>
                            <p [innerHTML]="productDetails.mainDescription">
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>